import { postToUrl } from '../../utils/postUtils';
import { assertUnreachable } from '../../utils/tsUtils';
import { setLobbyPlayerBank } from './lobbyActions';
import { becomeMttOwner, setMttStagingPlayerBank } from './mttStagingActions';
import { becomePokerRoomOwner, setPokerPlayerBank } from './pokerActions';
import { setSelfChips } from './selfDataActions';
import { disableBeforeUnload } from './sessionActions';
export const setPlayerBankFromInbound = (inbound) => {
    return function (dispatch, getState) {
        const state = getState();
        if (state.selfData.id === inbound.playerId) {
            // this inbound concerns yourself, so update chips there:
            dispatch(setSelfChips(inbound.numChipsInBank));
        }
        const currentRoomSceneType = getState().scene.roomSceneType;
        if (currentRoomSceneType) {
            switch (currentRoomSceneType) {
                case 'poker': {
                    dispatch(setPokerPlayerBank(inbound.playerId, inbound.numChipsInBank));
                    break;
                }
                case 'mttStaging': {
                    const mttStartingChips = 'mttStartingChips' in inbound ? inbound.mttStartingChips : 0;
                    dispatch(setMttStagingPlayerBank({
                        playerId: inbound.playerId,
                        numChipsInBank: inbound.numChipsInBank,
                        mttStartingChips
                    }));
                    break;
                }
                case 'lobby': {
                    dispatch(setLobbyPlayerBank(inbound.playerId, inbound.numChipsInBank));
                    break;
                }
                default: {
                    assertUnreachable(currentRoomSceneType);
                }
            }
        }
    };
};
export const becomeOwner = () => {
    return function (dispatch, getState) {
        const currentRoomSceneType = getState().scene.roomSceneType;
        switch (currentRoomSceneType) {
            case 'poker': {
                dispatch(becomePokerRoomOwner());
                break;
            }
            case 'mttStaging': {
                dispatch(becomeMttOwner());
                break;
            }
        }
    };
};
export const openPaymentsPortal = () => {
    return function (dispatch, getState) {
        const loginString = getState().gameEntry.loginString;
        if (loginString) {
            const { hostname } = new URL(location.href);
            postToUrl(`https://${hostname}/payments/`, {
                login: loginString
            });
        }
    };
};
export const openAdminView = (playerId) => {
    return function (dispatch, getState) {
        const loginString = getState().gameEntry.loginString;
        if (loginString) {
            const { hostname } = new URL(location.href);
            postToUrl(`https://${hostname}/sub_stats.php`, {
                login: loginString,
                id: playerId
            });
        }
    };
};
export const openSuperAdminAccount = () => {
    return function (dispatch, getState) {
        const loginString = getState().gameEntry.loginString;
        if (loginString) {
            const { hostname } = new URL(location.href);
            postToUrl(`https://${hostname}/account.php`, {
                login: loginString
            });
        }
    };
};
export const forceReload = () => {
    return function (dispatch) {
        dispatch(disableBeforeUnload());
        // Refresh the page to log out, but allow for the disabling of 'before unload' to propagate through Redux and affect <Beforeunload /> rendering first:
        setTimeout(() => {
            window.location.reload();
        }, 0);
    };
};
